import { render, staticRenderFns } from "./AdminBorrowRequests.vue?vue&type=template&id=740f1866&"
import script from "./AdminBorrowRequests.vue?vue&type=script&lang=js&"
export * from "./AdminBorrowRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports